/*
 * The calendar and its feed. The front-end manifest, see lib/docs/writing-an-extension.md.
 */
import { defineExtension } from '@lib/extensions/define';

import de from './locale/de';
import en from './locale/en';

export default defineExtension({
	name: 'calendar',
	locale: { de, en },
});
